import script from "./LangChangeBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./LangChangeBtn.vue?vue&type=script&setup=true&lang=ts"

import "./LangChangeBtn.vue?vue&type=style&index=0&id=856c54b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-856c54b6"]])

export default __exports__